export const lang = {
  
  
};

export const ar = lang;
